import React, { Component } from "react";
import { connect } from "react-redux";
import { changePassword_action } from "../../actions/user_login_auth_actions/user_login_auth_action";
import { withRouter } from "../../utils/withRouter";
import {
  confirmPasswordValidator,
  oldPasswordValidator,
  passwordValidator,
} from "../../utils/Validator";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../utils/Loader";
import { clearSessionStorage } from "../../utils/constants";
import Header from "../../common_components/Header";
/*
 * mapDispatchToProps
 */
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/*
 * mapStateToProps
 */
const mapStateToProps = (state) => ({
  ...state,
});

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      old_pass: "",
      new_pass: "",
      confirm_pass: "",
      isLoading: false,
      is_showNewpass: false,
      is_showOldpass: false,
      is_showConfirmpass: false,
      // is_forgotPassword: false,
    };
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleObscure = this.handleObscure.bind(this);
  }

  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      // console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    // clearSessionStorage("");
    this.setState({
      is_forgotPassword:
        this.props.location.state != null &&
        this.props.location.state.is_forgotPassword != null
          ? this.props.location.state.is_forgotPassword
          : false,
    });
  }

  handleObscure(pass) {
    const { is_showOldpass, is_showConfirmpass, is_showNewpass } = this.state;
    if (pass == "new_pass") {
      this.setState({ is_showNewpass: !is_showNewpass });
    } else if (pass == "old_pass") {
      this.setState({ is_showOldpass: !is_showOldpass });
    } else if (pass == "confirm_pass") {
      this.setState({ is_showConfirmpass: !is_showConfirmpass });
    }
  }

  handleChangePassword = () => {
    const { old_pass, new_pass, confirm_pass } = this.state;
    clearSessionStorage("");
    // console.log(old_pass, new_pass, confirm_pass);
    var errMsg = oldPasswordValidator(old_pass, new_pass);
    var errMsg2 = passwordValidator(new_pass);
    var errMsg3 = confirmPasswordValidator(confirm_pass, new_pass);
    if (errMsg != "" || errMsg2 != "" || errMsg3 != "") {
      toast.error(
        errMsg != ""
          ? errMsg
          : errMsg2 != ""
          ? errMsg2
          : errMsg3 != ""
          ? errMsg3
          : "",
        {
          theme: "colored",
          autoClose: 1000,
          hideProgressBar: true,
        }
      );
    } else {
      if (
        new_pass != "" &&
        confirm_pass != "" &&
        old_pass != "" &&
        new_pass == confirm_pass
      ) {
        this.setState({ isLoading: true });
        // console.log(old_pass, new_pass, confirm_pass);
        this.props
          .changePassword_action(old_pass, new_pass)
          .then((data) => {
            if (data.error != 1) {
              this.setState({ isLoading: false });
              toast.success(
                "Password changed successfully.Please login again.",
                {
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                }
              );
              setTimeout(() => {
                localStorage.clear();
                this.props.navigate("/login");
              }, 300);
            } else {
              this.setState({ isLoading: false });
              toast.error(data.msg, {
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.setState({ isLoading: false });
        toast.error("Please check your password", {
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    }
  };

  render() {
    const {
      old_pass,
      new_pass,
      confirm_pass,
      is_showOldpass,
      is_showConfirmpass,
      is_showNewpass,
      is_forgotPassword,
    } = this.state;

    return (
      <>
        {/* <Header /> */}
        {/* Left side menu */}
        {/* <Drawer /> */}

        {/* start page */}
        <main id="main" style={{ background: "#f8f8f8" }}>
          <Header data={[]} />
          <section
            style={{
              marginTop: "80px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100vh",
            }}
          >
            <div class="container ">
              <div
                class="form-wapper container_padd"
                style={{ maxWidth: "60%", width: "100%" }}
              >
                <div class="form-header">
                  <h2>Change Password</h2>
                  <p>
                    Your new password must be different from previously used
                    passwords.
                  </p>
                </div>
                <div class="form-body">
                  <form id="updatepasswordForm">
                    <div class="input-wrapper">
                      <label for="old_password">
                        Old Password<span className="required1">*</span>
                      </label>
                      {/* <input type="hidden" id="user_name" name="user_name" value="maker@copass.in" readonly="" /> */}
                      <input
                        value={old_pass}
                        id="old_password"
                        type={is_showOldpass == true ? "text" : "password"}
                        name="old_password"
                        placeholder=""
                        onChange={(e) =>
                          this.setState({ old_pass: e.target.value })
                        }
                      />
                      <span class="icon show-pass">
                        <i
                          class="fa fa-eye"
                          onClick={() => this.handleObscure("old_pass")}
                        ></i>
                      </span>
                      {/* <span id="req_old"></span> */}
                      {/* {old_pass == "" ? (
                        <span className="required1">old required*</span>
                      ) : (
                        <></>
                      )} */}
                    </div>
                    <div class="input-wrapper">
                      <label for="new_password">
                        New Password<span className="required1">*</span>
                      </label>
                      <input
                        value={new_pass}
                        id="new_password"
                        type={is_showNewpass == true ? "text" : "password"}
                        name="new_password"
                        placeholder=""
                        onChange={(e) =>
                          this.setState({ new_pass: e.target.value })
                        }
                      />

                      <span class="icon show-pass">
                        <i
                          class="fa fa-eye"
                          onClick={() => this.handleObscure("new_pass")}
                        ></i>
                      </span>
                      {/* <span id="req_new"></span> */}
                      {/* {new_pass == "" ? (
                        <span className="required1">new required*</span>
                      ) : (
                        <></>
                      )} */}
                    </div>
                    <div class="input-wrapper">
                      <label for="new_password">
                        Confirm Password<span className="required1">*</span>
                      </label>
                      <input
                        id="confirm_password"
                        type={is_showConfirmpass == true ? "text" : "password"}
                        value={confirm_pass}
                        name="confirm_password"
                        placeholder=""
                        onChange={(e) =>
                          this.setState({ confirm_pass: e.target.value })
                        }
                      />

                      <span class="icon show-pass">
                        <i
                          class="fa fa-eye"
                          onClick={() => this.handleObscure("confirm_pass")}
                        ></i>
                      </span>
                      {/* <span id="req_conf"></span> */}
                      {/* {confirm_pass == "" ? (
                        <span className="required1">confirm required*</span>
                      ) : (
                        <></>
                      )} */}
                    </div>
                    <a
                      href="javascript:void(0);"
                      class="btn btn-secondary"
                      onClick={() => {
                        this.handleChangePassword();
                      }}
                    >
                      Set New Password
                    </a>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </main>

        <ToastContainer />
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    changePassword_action,
  })(ChangePassword)
);
